import React, { createRef, RefObject, useState } from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { space } from 'styled-system'
import { HelpFill, HintPointer } from '@zuto/icons'
import { CloseToolTip } from '../../../icons'

interface HintProps extends React.HTMLAttributes<HTMLDivElement> {
  showHintByDefault: boolean
  onClick?: () => void
}

export interface HintTextProps extends React.HTMLAttributes<HTMLDivElement> {
  show: boolean
}

const StyledHintText = styled.div<HintTextProps>`
  ${themeGet('questionsAndHints.hints')};
  position: relative;
  transition: opacity .3s ease, max-height .6s ease-out,
  padding-top .3s ease , padding-bottom .3s ease;
  box-sizing: border-box;
  ${(props) => (space({ mt: 3, mb: 3, ...props }))};
  ${(props) => (props.show ? 'opacity: 1; max-height: 15em;' : 'opacity: 0; max-height: 0; overflow: hidden;')}
`

const HintButton = styled.button`
  ${themeGet('questionsAndHints.button')}
  border:none;
  background-color:transparent;
  align-self: flex-end;
  padding: 0 0 10px;
  height: 26px;
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const StyledHintPointer = styled(HintPointer)`
  position: absolute;
  right: -1px;
  top: -19px;
  pointer-events: none;
`

const Hint = ({ children, onClick, ...props }: HintProps): JSX.Element => {
  const [visible, setVisible] = useState(props.showHintByDefault)
  const hintText: RefObject<HTMLDivElement> = createRef()

  // React.useEffect(() => {
  //   setVisible(props.showByDefault);
  // }, [props.showByDefault]);

  const toggleVisibility = () => {
    if (onClick) {
      onClick()
    }
    setVisible((previousVal) => !previousVal)
    if (hintText.current?.style) {
      hintText.current.style.removeProperty('padding')
      hintText.current.style.removeProperty('margin')
    }
  }

  const transitionEnd = () => {
    if (!visible && hintText.current) {
      hintText.current.style.padding = '0'
      hintText.current.style.margin = '0'
    }
  }

  return (
    <>
      <HintButton aria-label="show hint message" data-testid="hint-button" onClick={toggleVisibility}>
        {visible ? <CloseToolTip /> : <HelpFill />}
      </HintButton>

      <StyledHintText
        {...props}
        data-testid="hint-message"
        ref={hintText}
        show={visible}
        style={!props.showHintByDefault ? { padding: 0, margin: 0 } : {}}
        onTransitionEnd={transitionEnd}
      >
        <StyledHintPointer />
        {children}
      </StyledHintText>
    </>
  )
}

export default Hint
